import { useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

export default function Sidebar() {
  const router = useLocation();
  const { logout } = useContext(AuthContext);
  return (
    <section
      className={
        'lg:block w-full lg:w-2/12 bg-white h-auto lg:min-h-screen shadow-xl fixed'
      }
    >
      <div className={'w-full p-0 lg:p-4'}>
        <div className={'p-2 flex flex-row items-start'}>
          <div>
            <h2 className={'font-bold text-2xl text-gray-500'}>SmartRewards</h2>
          </div>
        </div>
      </div>
      <div
        className={
          'w-full my-3 lg:my-5 overflow-auto flex flex-row lg:flex-col justify-between items-start'
        }
      >
        <ul className={'w-auto lg:w-full flex flex-row lg:flex-col'}>
          <Link to={'/dashboard'}>
            <li
              className={`w-full flex flex-row items-center px-3 lg:px-8 py-3 ${
                router.pathname === '/dashboard'
                  ? 'bg-yellow-100'
                  : 'hover:bg-yellow-400'
              } text-gray-500`}
            >
              <span className={'mr-5'}>
                <i className={'fas fa-columns text-xl'} />
              </span>
              <h2 className={'text-base'}>Dashboard</h2>
            </li>
          </Link>
          <Link to={'/dashboard/wallet'}>
            <li
              className={`w-full flex flex-row items-center px-3 lg:px-8 py-3 ${
                router.pathname === '/dashboard/wallet'
                  ? 'bg-yellow-100'
                  : 'hover:bg-yellow-400'
              } text-gray-500`}
            >
              <span className={'mr-5'}>
                <i className={'fas fa-wallet text-xl'} />
              </span>
              <h2 className={'text-base'}>Wallet</h2>
            </li>
          </Link>
          <Link to={'/dashboard/beneficiaries'}>
            <li
              className={`flex flex-row items-center px-3 lg:px-8 py-3 ${
                router.pathname === '/dashboard/beneficiaries'
                  ? 'bg-yellow-100'
                  : 'hover:bg-yellow-400'
              } text-gray-500`}
            >
              <span className={'mr-4'}>
                <i className={'fas fa-users text-xl'} />
              </span>
              <h2 className={'text-base'}>Beneficiaries</h2>
            </li>
          </Link>
          <Link to={'/dashboard/rewards'}>
            <li
              className={`flex flex-row items-center px-3 lg:px-8 py-3 ${
                router.pathname === '/dashboard/rewards'
                  ? 'bg-yellow-100'
                  : 'hover:bg-yellow-400'
              } text-gray-500`}
            >
              <span className={'mr-5'}>
                <i className={'fas fa-gift text-2xl'} />
              </span>
              <h2 className={'text-base'}>Rewards</h2>
            </li>
          </Link>
          <Link to={'/dashboard/notifications'}>
            <li
              className={`flex flex-row items-center px-3 lg:px-8 py-3 ${
                router.pathname === '/dashboard/notifications'
                  ? 'bg-yellow-100'
                  : 'hover:bg-yellow-400'
              } text-gray-500`}
            >
              <span className={'mr-5'}>
                <i className={'fas fa-bell text-2xl'} />
              </span>
              <h2 className={'text-base'}>Delivery Report</h2>
            </li>
          </Link>
          <button
            onClick={async () => {
              logout();
            }}
          >
            <li
              className={`flex flex-row items-center px-3 lg:px-8 py-3 text-gray-500`}
            >
              <span className={'mr-5'}>
                <i className={'fas fa-door-open text-2xl'} />
              </span>
              <h2 className={'text-base'}>Logout</h2>
            </li>
          </button>
        </ul>
      </div>
    </section>
  );
}
